define('Accessibility',[
    "jquery"
], function ($) {

    // Let the document know when the mouse is being used
    document.body.addEventListener('mousedown', function () {
        document.body.classList.add('using-mouse');
    });

    // Re-enable focus styling when Tab is pressed
    document.body.addEventListener('keydown', function (event) {
        if (event.key === 'Tab') {
            document.body.classList.remove('using-mouse');
        }
    });

    $('input[type=checkbox]').focus(function () {
        $(this).parent('.switch.js-facet').addClass("tabbed");
        })
        .blur(function () {
            $(this).parent('.switch.js-facet').removeClass("tabbed");
        });

    $('input[type=checkbox]').keydown(function (event) {
        var code = event.charCode || event.keyCode;
        if ((code === 32) || (code === 13)) {
            event.preventDefault();
            $(this).trigger('click');
        }
    });
});

